<template>
  <div class="d-activity-unfollow-user modal active">
    <div class="overlay" />

    <div
      v-if="user"
      class="modal-content"
    >
      <div class="modal-header">
        <h4>Unfollow user?</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        class="modal-body loadable"
        :class="{ 'loading': isProcessing }"
      >
        <div
          v-if="isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Removing post...
          </p>
        </div>

        <div class="loaded-content">
          <p class="space-bottom-2em">
            Please confirm that you would like to stop following
            <span>{{ user.firstname }} {{ user.lastname }}</span>.
          </p>

          <div class="button-pair right space-top-3em">
            <button
              :disabled="isProcessing"
              type="button"
              @click="dismiss"
            >
              Cancel
            </button>
            <button
              class="button-yellow"
              :disabled="isProcessing"
              type="button"
              @click="stopFollowingUser"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import followersService from '@d-services/followers-service/followers-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import modalMixin from '@d-mixins/modal';

export default {
  mixins: [
    modalMixin,
  ],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isProcessing: false,
  }),
  methods: {
    dismiss() {
      this.$emit('dismiss');
    },

    async stopFollowingUser() {
      this.$set(this, 'isProcessing', true);

      try {
        await followersService.stopFollowingUser(this.user.id);
        Vue.duiNotificationManager.success(`Stopped following ${ this.user.firstname } ${ this.user.lastname }.`);
        this.dismiss();
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },
  },
};
</script>
